import React from "react";
import Scout from "../../images/scout.jpg";
import Chewy from "../../images/chewy.jpg";
import Missy from "../../images/missy.jpg";
import "./AboutDogs.css";

interface DogCardProps {
  name: string;
  image: string;
  age: number;
  nickname: string;
  favoriteThing: string;
  description: string;
  bestDog: string;
  pronoun: string;
}

const DogCard: React.FC<DogCardProps> = ({
  name,
  image,
  age,
  nickname,
  favoriteThing,
  description,
  bestDog,
  pronoun,
}) => {
  return (
    <div className="dogs-content">
      <h2>Meet {name}</h2>
      <div className="dog-card">
        <img src={image} alt={`${name}`} />
        <div className="dog-facts">
          <span>Age: {age}</span>
          <span>Nickname: {nickname}</span>
          <span>Favorite thing: {favoriteThing}</span>
          <span>
            What {pronoun} like: {description}
          </span>
          <span>Best dog: {bestDog}</span>
        </div>
      </div>
    </div>
  );
};
const AboutDogs = () => {
  return (
    <div className="about-dogs-container">
      <div className="dogs-content">
        <DogCard
          name="Scout"
          image={Scout}
          age={8}
          nickname="Scouts"
          favoriteThing="Belly rubs"
          description="A loving cute dog"
          bestDog="Tied for 1st"
          pronoun="she's"
        />
        <DogCard
          name="Chewy"
          image={Chewy}
          age={4}
          nickname="Bud bud"
          favoriteThing="Playing with friends"
          description="A playful dog that is super cute"
          bestDog="Tied with Scout"
          pronoun="he's"
        />
        <DogCard
          name="Missy"
          image={Missy}
          age={15}
          nickname="Miss"
          favoriteThing="Eating and going for walks"
          description="A very sweet and hungry girl"
          bestDog="Tied with Scout and Chewy"
          pronoun="she's"
        />
      </div>
    </div>
  );
};
export default AboutDogs;
